import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { ActiveModulesResource } from 'app/models/ActiveModulesResource';
import { UserResource } from 'app/resources/user/user-resource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'vbn-module-settings',
  templateUrl: './module-settings.component.html',
  styleUrls: ['./module-settings.component.scss']
})
export class ModuleSettingsComponent implements OnInit {

  appointmentModule: boolean = false;

  selectedUser = (atob(localStorage.getItem("_sc")) === atob(null)) ? null : atob(localStorage.getItem("_sc"));
  errorMessage: any;
  
  constructor(private service: UtilsService,
    private translate: TranslateService,
    private _notification: NotificationsService) { }

  ngOnInit() {
    this.getAppointmentState();
  }

  getAppointmentState() {
    /* this.service.get("/admin/modules/getActiveModules")
      .subscribe((resp: ActiveModulesResource) => {
        console.log("response = ", resp)
        this.appointmentModule = resp.appointment
      }) */

      this.service.get('/admin/user/getProfile?userName=' + this.selectedUser)
      .subscribe(
        response => {
          this.appointmentModule = response.canUseAppointments;
        },
        error => this.errorMessage = <any>error);

  }


  save() {
    let userResource = new UserResource();
    userResource.canUseAppointments = this.appointmentModule;
    userResource.email = this.selectedUser;


    this.service.add("/admin/user/updateUserModules", userResource).subscribe(
      resp => {
        this.service.changeAppModuleEnable(this.appointmentModule);
        forkJoin([
          this.translate.get('Success'),
          this.translate.get('Module settings updated'),
        ]).subscribe(res => {
          this._notification.create(res[0], res[1], 'success')
        })
      }
    )
  }
}
